import './hero.css';
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const Hero = () => {
    return (
        <div class="text-center container-styling hero">
          <div class="container" id='hero-text'>
            <p>We're Getting Married!</p>
            <h1 class="animated-text">Rebecca & Nathan</h1>
            <p class="animated-text">May 31, 2025</p>
            <a href="/rsvp" class="btn rsvp-button animated-button" role="button">RSVP</a>
          </div>
          <div className="scroll-down-icon" onClick={() => document.getElementById('next-section').scrollIntoView({ behavior: 'smooth' })}>
            <span>&#x25BC;</span>
          </div>
        </div>
    );
}

export default Hero;